<h1 mat-dialog-title><button mat-button (click)="onNoClick()">CLOSE</button><button mat-button (click)="onCreateNew()">CREATE NEW</button>STRAIGHT BILL OF  LADING CONTAINER#:{{data.conteiner}}  </h1>
<div mat-dialog-content >
<div [formGroup]="formBillofLading">
    
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>From</mat-label>
    <input formControlName="From" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>From Street</mat-label>
    <input formControlName="FromStreet" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>From  Origin</mat-label>
    <input formControlName="fromorigin" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>To</mat-label>
    <input formControlName="To" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>To Street</mat-label>
    <input formControlName="ToStreet" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>To  Destination</mat-label>
    <input formControlName="todestination" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>Bill to</mat-label>
    <input formControlName="Bill" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>Bill to Street</mat-label>
    <input formControlName="BillStreet" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>PRO Number</mat-label>
    <input formControlName="pro" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>Date</mat-label>
    <input formControlName="DateHeader" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>Shipper Number</mat-label>
    <input formControlName="ShipperNumber" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>Route</mat-label>
    <input formControlName="Route" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>Vehicle Number</mat-label>
    <input formControlName="VehicleNumber" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>Amt$</mat-label>
    <input formControlName="Amt" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>C.O.D.FEE</mat-label>
    <input formControlName="codfee" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>PREPAID COLLECT</mat-label>
    <input formControlName="prepaidCollect" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>TOTAL CHARGES</mat-label>
    <input formControlName="totalCharges" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>SHIPPER</mat-label>
    <input formControlName="shipper" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>PER</mat-label>
    <input formControlName="perShipper" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>CARRIER</mat-label>
    <input formControlName="carrier" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>PER</mat-label>
    <input formControlName="perCarrier" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>DATE</mat-label>
    <input formControlName="dateCaarrier" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>Special Instructions</mat-label>
    <input formControlName="SpecialInstructions" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>Consignee Contact Name</mat-label>
    <input formControlName="ConsigneeContact" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>SIGNED</mat-label>
    <input formControlName="signed" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>NUMBER OF UNITS RECEIVED</mat-label>
    <input formControlName="unitReceived" matInput>
  </mat-form-field>
    <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>SHIPPER LOAD & COUNT</mat-label>
    <input formControlName="shipperLoad" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>CONSIGNEEUNLOAD
    </mat-label>
    <input formControlName="consigneunload" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-3">
    <mat-label>DATE</mat-label>
    <input formControlName="dateconsigne" matInput>
  </mat-form-field>
  <button mat-raised-button color="accent" (click)="OnsaveBillofLading()">Save</button>

</div>
<div *ngIf="viewites">
<div [formGroup]="formItems">
  <mat-form-field appearance="fill" class="col-md-2">
    <mat-label>Quantity</mat-label>
    <input formControlName="quantity" matInput>
  </mat-form-field>
  <mat-form-field appearance="fill" class="col-md-2">
    <mat-label>Unit</mat-label>
    <mat-select formControlName="type_unit">
      <mat-option value=" ">----</mat-option>
      <mat-option value="PLTS">PLTS</mat-option>
      <mat-option value="CTNS">CTNS</mat-option>
    </mat-select>
  </mat-form-field>

    <mat-form-field appearance="fill" class="col-md-2" *ngIf="false">
        <mat-label>HM</mat-label>
        <input formControlName="hm" matInput>
      </mat-form-field>
      <mat-form-field appearance="fill" class="col-md-3">
        <mat-label>Description</mat-label>
        <input formControlName="Description" matInput>
      </mat-form-field>  <mat-form-field appearance="fill" class="col-md-2">
        <mat-label>Weight</mat-label>
        <input formControlName="Weight" matInput>
      </mat-form-field>
      <mat-form-field appearance="fill" class="col-md-2">
        <mat-label>Class</mat-label>
        <input formControlName="Class" matInput>
      </mat-form-field>
      <mat-form-field appearance="fill" class="col-md-2">
        <mat-label>Charges</mat-label>
        <input formControlName="Charges" matInput>
      </mat-form-field>
      <button mat-raised-button color="accent" (click)="OnAddItems()">{{labelbtnadditems}}</button>
</div>
<div>
    <table>
        <thead>
            <tr>
                <th>Option</th>
                <th>Quantity</th>
                <th>Type</th>
                <th *ngIf="false">HM</th>
                <th>Description</th>
                <th>Weight</th>
                <th>Class</th>
                <th>Charges</th>
             
            </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of arrayItems; let i=index">
            <td>
              <button mat-icon-button [matMenuTriggerFor]="menuBillI" aria-label="Example icon-button with a menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menuBillI="matMenu">
                <button (click)="OnEditItems(item)" mat-menu-item>
               
                  <span>Edit</span>
                </button>
                <button (click)="onSelectItemsDelete(item.id_items)" mat-menu-item>
               
                  <span>Delete</span>
                </button>
            
              </mat-menu>

            </td>
            <td><b>{{item.quantity}}</b>  </td>
            <td><b>{{item.type_unit}}</b>  </td>
            <td *ngIf="false">{{item.hm}}</td>
            <td><b>{{item.Description}}</b></td>
            <td>{{item.Weight}}</td>
            <td>{{item.Class}}</td>
            <td>{{item.Charges}}</td>
          </tr>
        </tbody>
    </table>
</div>
</div>
</div>
<div mat-dialog-actions>
  

</div>
